// extracted by mini-css-extract-plugin
var _1 = "ConvertSharesStyle-module__convert-shares___ot3Ld";
var _2 = "ConvertSharesStyle-module__convert-shares___ot3Ld";
var _3 = "ConvertSharesStyle-module__custom-checkbox___pnZHE";
var _4 = "ConvertSharesStyle-module__custom-checkbox___pnZHE";
var _5 = "ConvertSharesStyle-module__holdings___Vt2gD";
export { _1 as "convert-shares", _2 as "convertShares", _3 as "custom-checkbox", _4 as "customCheckbox", _5 as "holdings" }
